import { isFirefox } from '@/Utils/Browser';
import WebStorage, { storageTypes } from '@/Utils/WebStorage';

export default isFirefox ? {
    props: {
        scrollKey: {
            type: String,
            default: 'scrollPosition',
        },
    },
    mounted() {
        this.scrollPositionStorage = new WebStorage(this.scrollKey, storageTypes.sessionStorage);

        const y = this.getSavedScrollPosition();
        if (y !== null) {
            setTimeout(() => {
                window.scrollTo(0, y);
            }, 0);
        }
        window.addEventListener('beforeunload', this.saveScrollPosition);
    },
    methods: {
        getSavedScrollPosition() {
            return this.scrollPositionStorage.get(this.scrollKey);
        },
        saveScrollPosition() {
            this.scrollPositionStorage.set(window.scrollY);
        },
    },
    beforeDestroy() {
        window.removeEventListner('beforeunload', this.saveScrollPosition);
    },
} : {};
